import React from 'react'
import { WorkOrderStatus as WorkOrderStatusEntries } from '@ztechapps/work-order.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

export const WorkOrderStatusBadge = ({ status, pill }: { status?: string; pill?: boolean }) => (
  <StatusColorBadge status={status} color={findStatus(WorkOrderStatusEntries, status)} pill={pill} />
)

export const WorkOrderStatus = ({ status }: { status: string }) => (
  <StatusColorDot value={status} color={findStatus(WorkOrderStatusEntries, status)} />
)
